import { TranslateModule } from '@ngx-translate/core';
import { Component } from '@angular/core';

@Component({
  selector: 'wo-weekly-recurrence',
  templateUrl: './weekly-recurrence.component.html',
  standalone: true,
  imports: [ TranslateModule ],
})
export class WeeklyRecurrenceComponent {}
